import React, { useEffect, useState } from "react";
import PersonForm from "./PersonForm";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import Notification from "../giftList/Notification";
import SantaHelp from '../HelpButtons/SantaHelp'

const SecretSanta = () => {
  const personData = [
    { id: 0, fullName: "", email: "", submitted: false },
    { id: 1, fullName: "", email: "", submitted: false },
    { id: 2, fullName: "", email: "", submitted: false },
    { id: 3, fullName: "", email: "", submitted: false },
  ];
  const [notification, setNotificationState] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [person, setPerson] = useState(personData);
  const [price, setPrice] = useState("");
  const [showPrice, setShowPrice] = useState(false);
  const [numPeople, setNumPeople] = useState("");
  const [formData, setFormData] = useState({});
  const [showData, setShowData] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [useStorage, setUseStorage] = useState(false);
  const navigate = useNavigate();
  const storedFormData = JSON.parse(sessionStorage.getItem("secret"));
  useEffect(() => {
    if (storedFormData) {
      setUseStorage(true);
      setFormData(storedFormData.persons);
      setShowData(true);
      setShowPrice(true);
    }
    // eslint-disable-next-line
  }, []);
  const setNotification = (notification) => {
    setNotificationState({ ...notification, show: true });
    setTimeout(() => {
      setNotificationState({ ...notification, show: false });
    }, 3000);
  };
  const handleAdd = () => {
    if (!numPeople) {
      setNotification({
        show: true,
        message: `Please first add how many people you want to participate!`,
        type: "danger",
      });
    } else {
      const newPerson = [
        ...person,
        {
          id:
            person.length === 0
              ? (person.id = 0)
              : person[person.length - 1].id + 1,
          fullName: "",
          email: "",
          submitted: false,
        },
      ];
      setPerson(newPerson);
    }
  };

  const handleFormSubmit = (id, fullName, email, submitted) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: { fullName, email, submitted },
    }));
    setPerson(person.map((p) => (p.id === id ? { ...p, submitted: true } : p)));
  };
/*  const setNumPeopleMin = (value) => {
    if (value < 4 || value === 0) {
      setNumPeople(4);
    } else {
      if (/^\d+$/.test(value)) {
        setNumPeople(value);
      }
    }
  };*/
  const setNumPeopleMin = (value) => {
    if (value < 4 || value === 0 || value%2 !== 0) {
      setNumPeople(4);
    } else {
      setNumPeople(value);
    }
  };
  const handleMaxPriceChange = (e) => {
    const value = e.target.value;
    if (/^\d+$/.test(value)) {
      setPrice(value);
    }
  };

  const handleDelete = (id) => {
    setPerson(person.filter((p) => p.id !== id));
    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };
      setNotification({
        show: true,
        message: `Successfully deleted! ${newFormData[id].fullName}`,
        type: "success",
      })
      delete newFormData[id];
      return newFormData;
    });
  };
  const createNamePairs = (names) => {
    const pairs = [];
    for (let i = 0; i < Object.keys(formData).length / 2; i++) {
      const pair = {};
      for (let j = 0; j < 2; j++) {
        const randomIndex = Math.floor(Math.random() * names.length);
        const randomName = names.splice(randomIndex, 1)[0];
        pair[`name${j + 1}`] = randomName;
      }
      pairs.push({ [`pair${i + 1}`]: [pair.name1, pair.name2] });
    }
    return pairs;
  };
  const allDone = (event) => {
    event.preventDefault();
    if (!price) {
      setNotification({
        show: true,
        message: `Please add the maximum price!`,
        type: "danger",
      });
    } else if (!numPeople) {
      setNotification({
        show: true,
        message: `Please first add how many people you want to participate!`,
        type: "danger",
      });
    } else if (Object.keys(formData).length !== Number(numPeople)) {
      setNotification({
        show: true,
        message: `Number of people you have set to participate must agree with the number of added people!`,
        type: "danger",
      });
    } else {
      const names = Object.values(formData).map((person) => person.fullName);
      const newPairs = createNamePairs(names);
      const sorted = person.map((item, index) => {
        return { ...item, id: index };
      });
      const data = {
        participants: Object.keys(formData).length,
        budget: price,
        pairs: newPairs,
        price: price,
        persons: sorted,
      };
      sessionStorage.setItem("secret", JSON.stringify(data));
      setRedirect(true);
    }
  };
  useEffect(() => {
    if (redirect) {
      navigate("/secret-santa-pairs");
    }
    // eslint-disable-next-line
  }, [redirect]);

  function crateNewList() {
    sessionStorage.removeItem("secret");
    window.location.reload();
  }
  return (
    <>
      <div>
        <h1>Secret Santa</h1>
      </div>
      <SantaHelp />
      <div style={{ width: "800px" }}>
        <div style={{ float: "left", width: "210px" }}>
          {showData ? (
            <>
              <h2 style={{ fontSize: "1.5em" }}>How many people ?</h2>
              <h2 style={{ fontSize: "1.5em" }}>{`${
                Object.keys(formData).length
              }/${useStorage ? storedFormData.participants : numPeople}`}</h2>
            </>
          ) : (
            <>
              <h2 style={{ fontSize: "1.5em" }}>How many people ?</h2>
              <input
                style={{ width: "70px" }}
                value={numPeople}
                onChange={(event) => setNumPeopleMin(event.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setShowData(true);
                  }
                }}
              />
              <p className="min-4-people">(min 4, evan people)</p>
            </>
          )}
        </div>
        <div style={{ float: "right", width: "210px", marginLeft: "50px" }}>
          {showPrice ? (
            <>
              <h2 style={{ fontSize: "1.5em" }}>Max price (BAM)</h2>
              <h2 style={{ fontSize: "1.5em" }}>
                {useStorage ? storedFormData.price : price}
              </h2>
            </>
          ) : (
            <>
              <h2 style={{ fontSize: "1.5em" }}>Max price (BAM)</h2>
              <input
                style={{ width: "70px" }}
                value={price}
                onChange={handleMaxPriceChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setShowPrice(true);
                  }
                }}
              />
            </>
          )}
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            marginTop: "130px",
          }}
        >
          {useStorage
            ? storedFormData.persons.map((value, index) => (
                <div key={index}>
                  <h3>Person:{index + 1}</h3>
                  <PersonForm
                    key={index}
                    id={value.id}
                    fullName={value.fullName}
                    email={value.email}
                    submitted={value.submitted}
                    handleSubmit={handleFormSubmit}
                    setPerson={setPerson}
                    person={person}
                    formData={formData}
                    handleDelete={handleDelete}
                  />
                </div>
              ))
            : person.map((value, index) => (
                <div key={index}>
                  <h3>Person:{index + 1}</h3>
                  <PersonForm
                    key={index}
                    id={value.id}
                    fullName={value.fullName}
                    email={value.email}
                    submitted={value.submitted}
                    handleSubmit={handleFormSubmit}
                    setPerson={setPerson}
                    person={person}
                    formData={formData}
                    handleDelete={handleDelete}
                  />
                </div>
              ))}
        </div>
      </div>
      {notification.show && (
        <Notification message={notification.message} type={notification.type} />
      )}
      <div className="btn-group flex-row">
        {useStorage ? (
          <Button variant="success" onClick={crateNewList}>
            Create a New List
          </Button>
        ) : (
          <Button
            variant="success"
            style={{ cursor: "pointer" }}
            onClick={handleAdd}
            disabled={person.length === Number(numPeople)}
          >
            Add person +
          </Button>
        )}
        {useStorage ? (
          <Button
            variant="success"
            onClick={() => navigate("/secret-santa-pairs")}
          >
            See Pairs
          </Button>
        ) : (
          <Button variant="success" onClick={allDone}>
            Done
          </Button>
        )}
      </div>
    </>
  );
};

export default SecretSanta;
